import React, {useEffect} from 'react';
import {menu,endMenu,loggedInMenu,notLoggedInMenu} from "src/datamodels/tdp";
import {isLoggedIn, makeAppTopMod} from "src/utilities/utilityFunctions";
import store from 'src/store';
import {gsap, Back,Power4} from "gsap";

const renderButtons = (lrgscrn,menuItems) => {
    let stateData = store.getState();
    const btnMaxWidth = stateData.appSettings.screenOrientation==='landscape' ? "25%":"33%" ;
    // const btnFont = stateData.appSettings.screenOrientation==='landscape' ? "1.5em": "1.65em";
    const btnFont = stateData.appSettings.screenOrientation==='landscape' ? "1.1em": "1.1em";
    // const buttonStyle={width:btnMaxWidth,maxWidth:btnMaxWidth,fontSize:btnFont,padding:'.5em,.5em,0,.5em',
    let wd = lrgscrn ? 200: 100 ;
    let ht = lrgscrn ? 280: 140 ;
    let bp = lrgscrn ? '0 -10px' : 'auto' ;
    let iconWd = lrgscrn ? 120: 60 ;
    const buttonStyle={width:wd,height:ht,fontSize:btnFont,padding:0,marginRight:5,border:'none',
        color:'#0080ff',fontFamily:'Arial',fontWeight:'bold',background:'transparent',opacity:0
    };

    let innerBtnStyle = {
        backgroundImage:'url(images/pennant4.png)',width:'100%',height:'100%',
        display:'grid',placeItems:'center',paddingBottom:20,marginBottom:10,
        backgroundSize:'cover',backgroundPosition:bp,backgroundRepeat:'no-repeat'
    }

    let iconStyle = {
        marginLeft:'auto',marginRight:'auto',marginBottom:20,width:'90px',height:'90px',
        borderRadius:'45px',boxShadow: '0px 12px 19px 5px rgba(0,0,0,0.4)'
    };

    return menuItems.map((item,i)=>{
        //if(item.label !=='Home') {
            let clickFunc = item.module ? ()=>makeAppTopMod(item.module) : item.click;
            return (
                <button className="mobileFrontScreenButton" style={buttonStyle} onClick={clickFunc} key={item.label}>
                    <div style={innerBtnStyle}>
                        <div style={{transform:'translateY(10px)'}}>
                            <div style={{marginLeft:'auto',marginRight:'auto',marginBottom:10,backgroundImage:`url(${item.icon})`,backgroundSize:'contain',
                                        width:iconWd,height:iconWd,borderRadius:iconWd/2,boxShadow: '0px 12px 19px 5px rgba(0,0,0,0.4)'
                                    }}>
                            </div>
                            <div style={{marginBottom:10,lineHeight:1}}>{item.label}</div>
                        </div>
                    </div>
                </button>
            )
        //}
    });
};

const SmallScreenMenuPage = (props) => {
    let stateData = store.getState();
    let largescreen = (["xl","lg"]).indexOf(stateData.appSettings.breakpoint) > -1;
    let middleMenu = isLoggedIn() ? loggedInMenu : notLoggedInMenu;
    let allMenu = menu.concat(middleMenu).concat(endMenu);
    let bg = props.modalMode ? null : 'url(images/small-screen-home-bg.png)';
    let outrHt = largescreen ? props.height: props.height - 45 ;
    let ht = largescreen ? props.height: "70%" ;
    let wd = stateData.appSettings.screenOrientation==='landscape' ? "70%":"100%" ;

    useEffect(()=>{
        gsap.set(".mobileFrontScreenButton",{x:-230,scale:0});
        gsap.to(".mobileFrontScreenButton",.75,{opacity:1,x:0,scale:1,stagger:.1,ease:Power4.easeOut});
    });
    return (
        <div id="smallScreenMenuPage" style={{display:'grid',placeItems:'center',width:"100%",backgroundImage:bg,backgroundSize:'cover',height:outrHt}}>
            <div style={{width:wd,height:'70%',display:'flex',flexWrap:"wrap",justifyContent:'space-around',paddingLeft:0,paddingRight:0}}>
                {renderButtons(largescreen,allMenu)}
            </div>
        </div>
    )


};

export default SmallScreenMenuPage
